module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Got It',
        maxProdsTitle: 'Maximum Products Reached',
        maxProdsDesc: 'You can only compare 3 products at a time. Remove one and try again.'
    };

    return resources[label];
};
